import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

import { adminPaths } from "admin/paths";
import AdminPageHeader from "components/admin/AdminPageHeader";
import { paymentPlansRepo, travelCmsRepo } from "data/repositories/mobileCmsRepo";

const TRAVEL_REPOS = {
  flights: travelCmsRepo.flights,
  buses: travelCmsRepo.buses,
  hotels: travelCmsRepo.hotels,
  tours: travelCmsRepo.tours,
  cars: travelCmsRepo.cars,
};

export default function MobileCmsEdit() {
  const { kind, id } = useParams();
  const navigate = useNavigate();
  const isNew = !id || id === "new";
  const isPlan = kind === "plans" || !kind;

  const repo = useMemo(() => {
    if (isPlan) return paymentPlansRepo;
    return TRAVEL_REPOS[kind] || travelCmsRepo.flights;
  }, [isPlan, kind]);

  const [jsonText, setJsonText] = useState("{\n  \"id\": \"\"\n}");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isNew) return;
    const item = repo.getById(id);
    if (!item) {
      setError("Kayıt bulunamadı");
      return;
    }
    setJsonText(JSON.stringify(item, null, 2));
  }, [id, isNew, repo]);

  const onSave = () => {
    try {
      const parsed = JSON.parse(jsonText);
      if (!parsed.id) throw new Error("id alanı zorunlu");
      if (isNew) {
        repo.create(parsed);
      } else {
        repo.update(id, parsed);
      }
      navigate(adminPaths.content.mobileCms.list, {
        replace: true,
        state: { status: { color: "success", message: "Kayıt kaydedildi" } },
      });
    } catch (saveError) {
      setError(saveError?.message || "Kaydedilemedi");
    }
  };

  return (
    <Container className="mt-4" fluid>
      <AdminPageHeader
        title={isNew ? "Yeni CMS kaydı" : "CMS kaydı düzenle"}
        subtitle="JSON olarak düzenleyin; kayıt Firebase’e senkronlanır."
      />
      {error ? <div className="alert alert-danger">{error}</div> : null}
      <Card>
        <CardHeader>
          <h3 className="mb-0">{isPlan ? "Ödeme planı" : `Seyahat / ${kind}`}</h3>
        </CardHeader>
        <CardBody>
          <FormGroup>
            <Label>JSON</Label>
            <Input type="textarea" rows={22} value={jsonText} onChange={(e) => setJsonText(e.target.value)} />
          </FormGroup>
          <Button color="primary" className="mr-2" onClick={onSave}>
            Kaydet
          </Button>
          <Button color="secondary" onClick={() => navigate(adminPaths.content.mobileCms.list)}>
            Vazgeç
          </Button>
        </CardBody>
      </Card>
    </Container>
  );
}
